<template>
  <div
    data-cy="file"
    :class="{ selected: auction.subastaId === selectedAuction }"
    class="row p-3 mt-2 shadow-sm bg-white"
  >
    <div class="col-11">
      <div class="row">
        <div class="col-1 text-center text-primary">
          <div
            data-cy="file-number"
            v-tooltip="'Folio Subasta'"
            :class="{ 'text-success': wasCopied }"
            class="cursor-pointer"
          >
            {{auction.folio}}
          </div>
          <b-form-checkbox
            v-model="auction.selected"
            @change="selectElement"
            data-cy="select"
          />
        </div>
        <div class="col-10">
          <div class="row">
            <div class="col-2">
              <b-badge
                pill
                :variant="auctionsStates[auction.estado].color"
                v-if="auctionsStates[auction.estado]"
                v-tooltip="'Estado Subasta'"
                class="p-2 font-weight-light"
              >
                {{auctionsStates[auction.estado].label}}
              </b-badge>
            </div>
            <div class="col-2">
              {{auction.fechaCreacion | dateFormat}}
            </div>
            <div class="col-2">
              {{auction.fechaSubasta | dateFormat}}
            </div>
            <div class="col-5">
              {{auction.gestoraNombre}}
            </div>
            <div class="col-1">
              <b>
                {{auction.valorCambio | amount}}
              </b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1 d-flex justify-center">
      <slot name="actions" v-bind:auction="auction">
        <AuctionsOptions
          :ref="'file-options-' + auction.id"
          :auction="auction"
          :select-auction="selectAuction"
          v-on:reload-list="handleReloadList"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AuctionsOptions from '@/febos/aduanas/auctions/views/components/AuctionsOptions';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import { auctionsStates } from '@/febos/aduanas/auctions/views/utils/constants';

export default {
  components: { AuctionsOptions },
  mixins: [CopyToClipboard],
  data() {
    return {
      auctionsStates
    };
  },
  props: [
    'auction',
    'selectAuction'
  ],
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('auctions', ['selectedAuction']),
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    selectElement() {
      if (this.auction.selected) {
        this.$emit('select-check-auction', this.auction);
        return;
      }
      this.$emit('unselect-check-auction', this.auction);
    },
    handleReloadList() {
      this.$emit('reload-list');
    }
  }
};

</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
.mother-indicator{
  width:160px;
  margin-left:50%;
  left: 80px;
}
</style>
